"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBoolean = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var reducers_1 = require("../reducers");
/**
 * Boolean state hook
 *
 * @param initialState {boolean} - initial state
 *
 * @return {BooleanState}
 */
function useBoolean(initialState) {
    var _a = react_1.default.useReducer(reducers_1.booleanReducer, initialState), state = _a[0], dispatch = _a[1];
    var handleToggle = react_1.default.useCallback(function () {
        dispatch('toggle');
    }, []);
    var handleTrue = react_1.default.useCallback(function () {
        dispatch('true');
    }, []);
    var handleFalse = react_1.default.useCallback(function () {
        dispatch('false');
    }, []);
    return [state, handleToggle, handleTrue, handleFalse];
}
exports.useBoolean = useBoolean;
//# sourceMappingURL=use-boolean.js.map